import { render, staticRenderFns } from "./purchaserList.vue?vue&type=template&id=a9961114&scoped=true"
import script from "./purchaserList.vue?vue&type=script&lang=js"
export * from "./purchaserList.vue?vue&type=script&lang=js"
import style0 from "./purchaserList.vue?vue&type=style&index=0&id=a9961114&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9961114",
  null
  
)

export default component.exports